export function getMonitoraggioApi(data, id, idSoggetto, tipo, token) {
	let newData = data;
	Object.entries(data).forEach(([key]) => {
		if (data[key] === "true10") {
			newData[key] = true;
		}
		if (data[key] === "true15") {
			newData = {
				...newData,
				tosse: data[key] === "true15",
				tosse15: data[key] === "true15"
			}
		}
		if (data[key] === "A" || data[key] === "0") {
			newData[key] = false
		}
		if (data[key] === "ND") {
			newData[key] = null
		}
	})
	return {...newData, idQuarantena: id, soggetto: idSoggetto, tipo: tipo, compilatoUtente: !!token};
}
